jQuery(document).ready(function($) { 

/*  ***************************
 VAR
******************************** */
var LARGEUR_MAX_MOBILE = 1023;
var header = $('#masthead');
	




/*  ***************************
  LIEN VERS ENFANT 
******************************** */

  $(".LinkToChild-js").click(function() {
      document.location = $(this).find("a").attr("href");
  });

/*  ***************************
 	SCROLL MAGIC BARRE ROUGE
******************************** */

	var EclateProduit = $("#masthead");
  var IntroPage = $(".IntroPage");
  var LARGEUR_MAX_MOBILE_ANIM = 1023;
  var l_window = parseInt($(window).width());
 if (l_window > LARGEUR_MAX_MOBILE_ANIM){

   if ( $( EclateProduit).length ) {
	
      // init controller
      var controller = new ScrollMagic.Controller();

      // 1. HOME PAGE //

      // A - TOP INTRO 
      var scene = new ScrollMagic.Scene({
							triggerElement: "#trigger_bar_top",
							duration: 500
						})
						.setTween("#RedBarHomeTop", 1, {left: "80%" }) // scale : 2.5 // trigger a TweenMax.to tween
						//.addIndicators({name: "1 (duration: 0)"}) // add indicators (requires plugin)
						.addTo(controller);

      // B - TOP BLOG 
      var scene2 = new ScrollMagic.Scene({
              triggerElement: "#Trigger_BlogTop",
              duration: 500,
              offset: -120
            })
            .setTween("#RedBarBlogTop", 1, {left: "80%" }) // scale : 2.5 // trigger a TweenMax.to tween
            //.addIndicators({name: "1 (duration: 0)"}) // add indicators (requires plugin)
            .addTo(controller);

      // FOOTER ALL PAGE
      // Z - PARTENAIRE - FOOTER 
      var scene3 = new ScrollMagic.Scene({
              triggerElement: "#Trigger_ParterTop",
              duration: 500,
              offset: -120
            })
            .setTween("#RedBarParterTop", 1, {left: "80%" }) // scale : 2.5 // trigger a TweenMax.to tween
            //.addIndicators({name: "1 (duration: 0)"}) // add indicators (requires plugin)
            .addTo(controller);

  }

  if ( $( IntroPage).length ) {
  
      // init controller
      var controller2 = new ScrollMagic.Controller();

      var scene = new ScrollMagic.Scene({
            triggerElement: "#trigger_intro_t",
            offset: +20,
            duration: 500
          })
          .setTween('#RedBarService_intro', 1, {top: "32%" }) // scale : 2.5 // trigger a TweenMax.to tween
          //.addIndicators({name: "1 (duration: 0)"}) // add indicators (requires plugin)
          .addTo(controller2);


      // 1. HOME PAGE //

      // A - TOP INTRO 
      var scene = new ScrollMagic.Scene({
              triggerElement: "#trigger_bar_top",
              duration: 500
            })
            .setTween("#RedBarHomeTop", 1, {top: "80%" }) // scale : 2.5 // trigger a TweenMax.to tween
            //.addIndicators({name: "1 (duration: 0)"}) // add indicators (requires plugin)
            .addTo(controller2);


  }






 	} // FIN IF 
 

 	 $(window).scroll(function () {
      action_on_scroll();
    });

    function action_on_scroll(){

      var l_window = parseInt($(window).width());
      h_header = $("#masthead").height();

      if (l_window > LARGEUR_MAX_MOBILE){
         if ($(window).scrollTop() > h_header - 30){
          header.addClass("Masthead--sticky");
          }else{
                header.removeClass("Masthead--sticky");
          }
      }else{

        if ($(window).scrollTop() > 0){
          header.addClass("fixed_scrol_mobile");
              }else{
                header.removeClass("fixed_scrol_mobile");
              }
      }
   }



/*  ***************************
 	SLIDE BLOCK !!
******************************** */


 /* Gallerie SLIDER POST RELATED */
$('.SlideBloc-Inner-js').slick({
      //setting-name: setting-value
      dots: false,
      arrows:true,
      speed:1400,
      infinite:true,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows:true,
            dots: true
          }
        },
        {
          breakpoint: 700,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows:true,
            dots: false
          }
        }
     ]
}).on('setPosition', function (event, slick) {
    slick.$slides.css('height', slick.$slideTrack.height() + 'px');
});



/*  ***************************
 PARTENAIRES SLIDER
******************************** */

$('.PartersFooter-Slide-js').slick({
      //setting-name: setting-value
      dots: true,
      arrows:false,
      speed:1400,
      infinite:true,
      slidesToShow: 4,
      slidesToScroll: 4,
      autoplay:true,
      responsive: [
      {
          breakpoint: 1154,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
             arrows:false,
            dots: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
             arrows:false,
            dots: true
          }
        }
     ]
});




}); // fin ready menu